//REGISTER

export const API_PREFIX = "/api";
export const TOKEN_KEY = "user_token";
export const APPLICATION_EXT = "/user";
//REGISTER
export const MASTER_MS_EXT = "/master";
export const ADMIN_MS_EXT = "/admin";
export const USER_MS_EXT = "/user";
export const LOG_MS_EXT = "/log";
export const GP_MS_EXT = "/gp";
export const MEMO_MS_EXT = "/memo";
export const DPWD_MS_EXT = "/dpwd";
export const REPORT_MS_EXT = "/report";

export const COMMON_API = {
    login: "/user/login",
    loadCaptcha: "/user/loadCaptcha",
    isLoggedIn: "/user/isLoggedIn",
    logout: "/user/logout",
    me: "/user/me",
};

export const MASTER_API = {
    languageDD: "/languageDD",
    getConsumerComplain: '/getConsumerComplain',
    getTenantTemplateCSS: '/getTenantTemplateCSS',
};

export const ADMIN_API = {
    getRule: "/getRule",
    promotionCategoryNameDD: "/promotionCategoryNameDD",
    listTenantSocialMedia: "/listTenantSocialMedia",
    readFile: "/readFile",
    getClientDetails: "/getClientDetails",
    listAppData: '/listAppData',
    getTextRunningData: '/getTextRunningData',
    showTenantPageData: "/showTenantPageData",
    promotionCategoryNameDD: "/promotionCategoryNameDD",
    getTenantSiteMap: '/getTenantSiteMap',
    getTextRunningData: '/getTextRunningData',
};

export const USER_API = {
    login: "/login",
    loadCaptcha: "/loadCaptcha",
    isLoggedIn: "/isLoggedIn",
    logout: "/logout",
    listPlayerAlternativeSite: "/listPlayerAlternativeSite",
    listBlog: "/listBlog",
    getBlog: "/getBlog",
    listPlayerBlogCategory: "/listPlayerBlogCategory",
    verifyWithEmail: "/verifyWithEmail",
    validateBankDetails: "/validateBankDetails",
    verifyWithBankDetails: "/verifyWithBankDetails",
    verifiedToken: "/verifiedToken",
    verifyToken: "/verifyToken",
    verifyEmailToken: "/verifyEmailToken",
    changeEmail: "/changeEmail",
    updatePinStatus: "/updatePinStatus",
    checkToken: "/checkToken",
    listUserMenu: "/listUserMenu",
    listTenantBank: "/listTenantBank",
    bankDD: "/bankDD",
    securityQuestionDD: '/securityQuestionDD',
    userRegistration: '/userRegistration',
    changePassword: '/changePassword',
    getBankValidationCode: '/getBankValidationCode',
    emailVerification: '/emailVerification',
    getPlayerProfileDetail: '/getPlayerProfileDetail',
    sendPlayerMessage: '/sendPlayerMessage',
    go: '/go',
    setUserNewPin: '/setUserNewPin',
    checkIfPinAlreadySet: '/checkIfPinAlreadySet',
    checkValidatePin: '/checkValidatePin',
    addUpdatePlayerSecurityQuestion: '/addUpdatePlayerSecurityQuestion',
    lastActiveAt: '/lastActiveAt',
    getValidationStatus: '/getValidationStatus',
    listPageMetaInfo: '/listPageMetaInfo',
    listPageFooterInfo: '/listPageFooterInfo',
    getTextInfo: '/getTextInfo',
    listProviderGame: '/listProviderGame',
    oldPassword: '/oldPassword',
    reminderPassword: '/reminderPassword',
    playerBankDD: '/playerBankDD',
    referralPlayerCountUpdate: '/referralPlayerCountUpdate',
    listReferralPlayer: '/listReferralPlayer',
    getUserAppOtherMedia: '/getUserAppOtherMedia',
    listReferralCount: '/listReferralCount',
    getProviderIcon: '/getProviderIcon',
    updateMyLanguage: '/updateMyLanguage',
    listLanguageUserData: '/listLanguageUserData',
    checkDuplicateUsername: '/checkDuplicateUsername',
    listInfoTurnover: '/listInfoTurnover',
    listHistoryTurnover: '/listHistoryTurnover',
    listAppData: '/listAppData',
    getPlayerReferralDetail: '/getPlayerReferralDetail',
    addReferralValidationData: '/addReferralValidationData',
    getReferralValidationStatus: '/getReferralValidationStatus',
    userTenantBankDD: '/userTenantBankDD',
    resetUserPassword: '/resetUserPassword',
    getBlockedCountryList: '/getBlockedCountryList',
    getProviderJackpot: '/getProviderJackpot',
    addUpdatePlayerThemeMode: '/addUpdatePlayerThemeMode',
    userBankDetailRegister: '/userBankDetailRegister',
    beforeLoginUserRegistration: '/beforeLoginUserRegistration',
    listGameProvider: '/listGameProvider',
    getCategorywiseGameCount: '/getCategorywiseGameCount',
    getNewGame: '/getNewGame',
    getHotGame: '/getHotGame',
    userBankDetailRegister: '/userBankDetailRegister',
    beforeLoginUserRegistration: '/beforeLoginUserRegistration',
    getCategorywiseGameCount: '/getCategorywiseGameCount',
    getLiveChatConfig: '/getLiveChatConfig',
    getCategoryWiseTurnOver: '/getCategoryWiseTurnOver',
    // update social media count 
    updateSocialMediaCount: '/updateSocialMediaCount',
    getPlayerGameBlock: '/getPlayerGameBlock',
    referralPlayerList: '/referralPlayerList',
    referralPlayerList: '/referralPlayerList',
    getPlayerGameBlock: '/getPlayerGameBlock',
    addUpdateOnlinePlayer: "/addUpdateOnlinePlayer",
};

export const LOG_API = {

};

export const GP_API = {
    getBalance: "/getBalance",
    tenantToggleDD: "/tenantToggleDD",
    getLotteryResultDetail: "/getLotteryResultDetail",
    tenantCategoryProviderDD: "/tenantCategoryProviderDD",
    providerWiseCategoryDD: "/providerWiseCategoryDD",
    getLotteryResult: "/getLotteryResult",
    playerRedirection: "/playerRedirection",
    transferIn: "/transferIn",
    tenantLotteryProviderDD: "/tenantLotteryProviderDD",
    transactionTypeDD: "/transactionTypeDD",
    checkNegativeProviderBalance: "/getNegativePlayerProviderBalance",
    loadHkbLobby: '/loadHkbLobby',
    lotteryCategoryProviderGameDD: "/lotteryCategoryProviderGameDD",
    allProviderSubProviderDD: "/allProviderSubProviderDD",
};

export const MEMO_API = {
    // WL2-1036
    storeMessageInMongoDB: "/storeMessageInMongoDB",
    chatCompletion: "/chatCompletion",
    generateSummary: "/generateSummary",
    connectChat: "/connectChat",
    userMessage: "/userMessage",
    closeChatByUser: "/closeChatByUser",
    dumpAllMessages: "/dumpAllMessages",
    addConsumerCompaint: "/addConsumerCompaint",
    listConsumerCategory: "/listConsumerCategory",
    loadCaptcha: "/loadCaptcha",
    getPlayerUnreadMessageCount: "/getPlayerUnreadMessageCount",
    listPlayerOutboxMessage: "/listPlayerOutboxMessage",
    playerComposeMessage: "/playerComposeMessage",
    playerUpdateMessageStatus: "/playerUpdateMessageStatus",
    deletePlayerMessage: "/deletePlayerMessage",
    listPlayerInboxMessage: "/listPlayerInboxMessage",
    sendPlayerMessage: "/sendPlayerMessage",
    getUnreadPopUpMessage: "/getUnreadPopUpMessage",
    updatePopupMessageStatus: "/updatePopupMessageStatus",

};

export const DPWD_API = {
    listLastTenWithdrawRequest: '/listLastTenWithdrawRequest',
    addWithdrawRequest: '/addWithdrawRequest',
    checkPendingTransaction: '/checkPendingTransaction',
    getTenantWithdrawConfig: '/getTenantWithdrawConfig',
    getDepostListTen: '/getDepostListTen',
    getBankDetail: '/getBankDetail',
    depositAmount: '/depositAmount',
    depositWithdrawNotificationMessage: '/depositWithdrawNotificationMessage',
    depositWithdrawReadMessage: '/depositWithdrawReadMessage',
    listLastTenDepositwithdrawRequest: '/listLastTenDepositwithdrawRequest',
    checkWithdrawPendingRequest: '/checkWithdrawPendingRequest',
    listPlayerAllTransation: '/listPlayerAllTransation',
    downloadQRRead: '/downloadQRRead',
    dynamicQris: '/dynamicQris',
    generateMinMaxRange: '/generateMinMaxRange',
    generateMinMaxWithdrawRange: '/generateMinMaxWithdrawRange',
    generateCryptoAddress: '/generateCryptoAddress',
    getCryptoCharges: '/getCryptoCharges',
    cryptoCurrencyDD: '/cryptoCurrencyDD',
    cryptoNetworkDD: '/cryptoNetworkDD',
    listPlayerActivePromotion: '/listPlayerActivePromotion',
    listPlayerBonusInformation: '/listPlayerBonusInformation',
    isAddressAllocated: '/isAddressAllocated',
};

export const REPORT_API = {
    getLatestJackpot: "/getLatestJackpot",
    getOutStandingBetDetail: "/getOutStandingBetDetail",
};

export const MASTER_LOGIN = "/login";

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//Mails
export const GET_INBOX_MAILS = "/inboxmails";
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

// JOBS
export const GET_JOB_LIST = "/jobs";
export const ADD_NEW_JOB_LIST = "/add/job";
export const UPDATE_JOB_LIST = "/update/job";
export const DELETE_JOB_LIST = "/delete/job";

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply";
export const DELETE_APPLY_JOB = "add/applyjob";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//TASKS
export const GET_TASKS = "/tasks";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";
